// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"719":"c72a3183","892":"656b6e23"}[chunkId] + ".css";
};